import { AddressHint, ChildHint, EmployeeHints, PersonHint } from '@tpa/api';

export { AddressHint, ChildHint, EmployeeHints, PersonHint };

/** The three kinds of historical data an employee can be offered as a quick-fill hint. */
export type HintKind = 'address' | 'child' | 'person';

/** A single hint prepared for display in the picker dialog. */
export interface HintItem {
  /** The raw hint returned by the backend, emitted back on pick. */
  raw: AddressHint | ChildHint | PersonHint;
  /** Primary line (name / street). */
  title: string;
  /** Secondary line (birth number / date / city / country), when available. */
  subtitle?: string;
}

/** An empty result used whenever there is no owner/tenant context or the request fails. */
export const EMPTY_HINTS: EmployeeHints = {
  addresses: [],
  children: [],
  otherPersons: [],
};
